import * as React from 'react';
import boxingGloveImage from '../../../../assets/boxing-glove.png';

interface IProps {
	className?: string;
	fill?: string;
	width?: number;
	height?: number;
}

export const BoxingGloveIcon: React.FC<IProps> = ({ className, width = 20, height = 20 }) => (
	<img
		className={className}
		src={boxingGloveImage}
		alt='Boxing Glove'
		width={width}
		height={height}
		style={{ verticalAlign: 'middle' }}
	/>
);
